module.exports = __webpack_public_path__ + "img/aiAutomation.04fa7a6d.png";